<template>
	<div  style="width: 100vw;" :style="{minHeight:`calc(100vh - ${placeNavHeight}px)`}">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading  color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div style="height: 30px;width:  1px;"></div> -->
		
		<!-- <div :style="equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		...boxStyleOne,
		 	}:{
		 		width:'96%'
		 	}" v-if="data" style="margin: auto;display: flex;background-color: #fff;">
			<div @click="goAnchor(item)" class="tit" :style="{width:getWidth()}"
				style="padding: 4px 4px;border: solid 1px #d6d6d6 ;display: flex;align-items: center;justify-content: center;cursor: pointer;"
				v-for="(item,index) in headList" :key="index">
				{{item}}
			</div>
		</div> -->
		<div :style="equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		...boxStyleOne,
				minHeight:`calc(100vh - ${placeNavHeight}px)`
				
				
		 	}:{
		 		width:'96%',
				minHeight:`calc(100vh - ${placeNavHeight}px)`
		 	}" v-if="data" style="margin: auto;background-color: #fff;">
			<div v-if="data && data.brands.length == 0" style="display: flex;justify-content: center;width: 100%;" >
				<el-empty style="margin: auto;margin-top: 40px;"
					:description="$t('h.noData')"></el-empty>
			</div>
			<div style="display: flex;align-items: center;flex-wrap: wrap;border-top: solid 1px #d6d6d6;padding-top: 20px;padding-bottom: 20px;"
				v-for="(item,index) in data.brands" :key="index">
				<div :id="'selector' + index " style="margin-left: 4px;">
					{{index}}
				</div>
				<div @click="navTo(brand)" v-for="(brand,brandIndex) in item" :key="brandIndex" style="">
					<img style="width: 120px;height: 120px;object-fit: contain;margin-left: 20px;border: solid 1px #e2e2e2;cursor: pointer;"
						:src="brand.logo" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getBrandsData,
		getUrl_name
	} from '../../../api/all.js'
	export default {
		props: {
			footerHeight: {
				type: Number,
				default: 0
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				
				loading: false,
				data: null,
				headList: []
			}
		},
		mounted() {
			
			this.getData()
		},
		methods: {
			async navTo(item) {
				try {
					this.loading = true
					console.log('item',item)
					
					// const data = await getUrl_name({
					// 	type:"brands",
					// 	id:item.id
					// })
					// console.log('datadata',data)
					this.$router.push({
						path: '/brands/' + item.url_name
					})
					this.loading = false
				}catch(e) {
					this.loading = false
				}
			},
			//锚点跳转
			goAnchor(selector) {
				/*参数selector是id选择器（#anchor14）*/
				document.querySelector('#' + 'selector' + selector ).scrollIntoView({
					behavior: "smooth"
				});
			},
			getWidth() {
				let num = 100 / this.headList.length
				return num + '%'
			},
			async getData() {
				try {
					this.loading = true
					const data = await getBrandsData()
					this.data = data.data.data
					for (let k in this.data.brands) {
						this.headList.push(k)
					}
					console.log('data', data)
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			}
		}
	}
</script>

<style scoped>
	.tit:hover {
		background-color: #ebebeb;
	}
</style>